import { createBrowserRouter, Outlet, RouterProvider } from "react-router";
import { RootRouter } from "../../app";
import { MainMenu } from "../config/data.types";
import store from "../store"
import { RequireAuth } from "../modulos/logIn/view";
import { statusAppController } from "../modulos/root/root.controller";
import { startRouterLogIn } from "../modulos/logIn/logIn.router";
import { startRouterUsuario } from "../modulos/usuario/usuario.router"
import { startRouterAtendimento } from "../modulos/atendimento/atendimento.router"
import { startRouterProcedimento } from "../modulos/procedimento/procedimento.router"
import { startRouterPaciente } from "../modulos/paciente/paciente.router"


export const AninharView = Outlet;
export const menuRotas: MainMenu[] = [];

const WrapperRootPage = () => {
    return (
        <RequireAuth>
            <RootRouter />
        </RequireAuth>
    )
}

export const rotas = createBrowserRouter([
    startRouterLogIn(),
    {
        path:"/",
        element:<WrapperRootPage/>,
        children:[
            startRouterAtendimento(),
            startRouterPaciente(),
            startRouterProcedimento(),
            startRouterUsuario(),
        ]
    }
])


export const Roteador = () => {
    console.log("Iniciou o roteador.")
    rotas.navigate("/")
    store.dispatch(statusAppController.reducer.actions.startApp());
    return (
        <RouterProvider router={rotas} />
    )
}